import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Zap, Clock } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-charcoal text-cream py-20 md:py-32 overflow-hidden" data-id="element-37">
      {/* Subtle radial golden glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-96 bg-gold/10 blur-[100px] rounded-full pointer-events-none" data-id="element-38" />

      <div className="relative max-w-4xl mx-auto px-4 text-center" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-40">
          <div className="flex justify-center mb-6" data-id="element-41">
            <span className="text-gold text-2xl" data-id="element-42">✝</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight mb-6 text-balance" data-id="element-43">
            ¿Sientes que Dios te llamó a Emprender, pero el miedo y la falta de
            un sistema te tienen estancado?
          </h1>

          <h2 className="text-lg md:text-2xl text-cream/80 font-sans max-w-3xl mx-auto mb-10 leading-relaxed text-balance" data-id="element-44">
            Cómo Construir un Negocio que Glorifique a Dios y Genere{' '}
            <span className="text-gold font-semibold" data-id="element-45">
              $5,000 - $10,000 al Mes
            </span>{' '}
            en EE.UU., sin sacrificar tus valores ni el tiempo con tu familia.
          </h2>

          <div className="flex flex-col items-center gap-4" data-id="element-46">
            <Button className="w-full md:w-auto" onClick={() => document.getElementById('pricing-cta')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })} data-id="element-47">
              SÍ, QUIERO EMPRENDER CON UNCIÓN
            </Button>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-6 text-sm text-cream/60" data-id="element-48">
              <div className="flex items-center gap-1.5" data-id="element-49">
                <ShieldCheck className="w-4 h-4 text-gold" data-id="element-50" />
                <span data-id="element-51">Pago seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-52">
                <Zap className="w-4 h-4 text-gold" data-id="element-53" />
                <span data-id="element-54">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-55">
                <Clock className="w-4 h-4 text-gold" data-id="element-56" />
                <span data-id="element-57">Garantía de 7 días</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}